import { useState, useRef, Fragment } from "react";
import Config from "../../Config";
import PlTitle from "../../elements/PlTitle";
import InputTextAlpha from "../../helpers/InputTextAlpha";
import InputCombo from "../../helpers/InputCombo";
import InputPagger from "../../helpers/InputPagger";
import InputLegend from "../../helpers/InputLegend";
import InputText from "../../helpers/InputText";


import edit from "../../edit.png";
import trash from "../../trash.png";
import CardsEdit from "./CardsEdit";
import CardNew from "./CardNew";
import SortBy from "../../helpers/SortBy";
import MenuTable from "../../helpers/MenuTable";
import AppContext from "../../AppContext";
import CardImport from "./CardImport";


function Cards(props)
{
    const [refreshView, setRefreshView] = useState(props.userData.refreshView);

    const [filter, setFilter] = useState(null);
    const [filterParam, setFilterParam] = useState({  
        card_id: props.mainView.readFilter('card_id',''), 
        karta_opis: props.mainView.readFilter('karta_opis',''), 
        przypisane: props.mainView.readFilter('przypisane',''), 
        d_imie_nazwisko: props.mainView.readFilter('d_imie_nazwisko',''), 
      
        sortBy: {
            sort:  "", //asc desc,
            column: "",
        },

        limit: 50,
        page: 1,
        pages: 1,
        show: true,
    });
    const [tab, setTab] = useState(null);
    const [selectedRow, setSelectedRow] = useState([]);



    

    const tabRef = useRef(0); //do druku


    const [view, setView] = useState ( {
        v:'list',
        id: -1
    } );

    const [legend, setLegend] = useState([
        {
            cls:'color_deleted',
            title: 'Karta nieaktywna'
        },
    ]);




    //-------------------------------------------------------
    //-------------------------------------------------------
    //MASS
    const changeSelected = (e) => {

        var id    = e.target.getAttribute('atr-id');   
        var selected = 0;

        if(e.target.checked) selected = 1;

        for(var k=0; k<selectedRow.length; k++)
        {
            if(selectedRow[k].id == id)  selectedRow[k].selected = selected;
        }

        setSelectedRow(  JSON.parse(JSON.stringify(selectedRow) ) );    
    }

    const changeSelectedAll = (e) => {

        var s = selectedRow[0].selected;
        if(s == 1) {  s = 0; } else s = 1;

        for(var k=0; k<selectedRow.length; k++)
            {
            selectedRow[k].selected = s;
            }
        
            setSelectedRow(  JSON.parse(JSON.stringify(selectedRow) ) ); 

    }


//-------------------------------------------------------
//-------------------------------------------------------



const getTab = () => {
       
 
    props.mainView.setProgress(-2);

   

    fetch( Config.url + '/rest_v1_access,cards', {
        method: 'POST', 
        body: JSON.stringify(filterParam), 
        headers: {
            'Content-Type': 'application/json',                    
            'X-Api-Key': props.userData.apiKey,
            '_p_przedszkole_id_': props.userData.p_przedszkole_id,
            '_p_dziecko_id_': props.userData.p_dziecko_id,
            '_sec_key_': Config.genXKey() ,
        }
     })
     .then(res => res.json() )
     .then(res => { 

                props.mainView.setProgress(-1);        
                if(res._sys_ == undefined)
                {
                    props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                }else
                if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                {
                    props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                }else    
                {
                    setTab(res.result);            


                    var newSelector = [];

                    res.result.forEach( (item) => {
                        newSelector.push({
                            id: item.id,
                            title: item.imie  + "  " + item.nazwisko,
                            selected: 0,
                        });
                    } )

                    setSelectedRow(newSelector);


                    if(res.pages != undefined )setFilterParam( {...filterParam,   ['pages']: res.pages  } );             
                }
     } )
     .catch(err => {          
                props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                props.mainView.setProgress(-1);
     });
               

     return false;
}



const valChangeListener = (filedName, val, correct, msg) => {

    //console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg);

     setFilterParam( {...filterParam, [filedName]:val,  [filedName+"_valid"]:correct } );
     
     if(   (val.length == 0 || val.length > 2 || msg =='combo')  && filterParam[filedName] != val )
        {
                var defTimeOut = 1000;
                if(msg == 'combo') defTimeOut = 10;
                clearTimeout(AppContext.timeoutId);
                AppContext.timeoutId = setTimeout( () => {
                    setTab(null); 
                } , defTimeOut );
        }

     props.mainView.writeFilter(filedName, val);
 }


 const goNextNew = () => {
     console.log("goNext");    
     setTab(null);    
 }


 const filterView = () => {
    setFilterParam(  {...filterParam, ["show"]:!filterParam.show } );
}

 const filterClear = () => {
 
    props.mainView.writeFilter('card_id', '');
    props.mainView.writeFilter('karta_opis', '');
    props.mainView.writeFilter('przypisane', '');
    props.mainView.writeFilter('d_imie_nazwisko', '');    
  

     setFilterParam({
       
         card_id: '',                 
         karta_opis: '',                 
         przypisane: '',                 
         d_imie_nazwisko: '',                 

         sortBy: {
            sort:  "", //asc desc,
            column: "",
        },


         limit: 50,
         page: 1,
         show: true, 
     });
     setTab(null);
 }

 const filterApprove = () => {   
     setTab(null)     
 }

 const onChangePagger = (x_limit, x_page) => {

     setFilterParam(  {...filterParam, ["limit"]:x_limit, ["page"]:x_page} );
     setTab(null);
 }


 
 const onChangeSortBy = (sortBy) => {

    setFilterParam(  {...filterParam, ["sortBy"]:sortBy } );
    setTab(null);
}



 const changeView = (e ) => {
    var v = e.target.getAttribute('v');
    var id = e.target.getAttribute('id');

    setView({...view, ["v"]:v, ["id"]:id });
}


const onBack = () => {
       
    setView({...view, ["v"]:"list", ["id"]:-1 }); 
   
}

const onSuccess = () => {
       
    console.log("Cards onSuccess");
    setView({...view, ["v"]:"list", ["id"]:-1 }); 
    getTab();
}


const searchId = (cardId) => {
      setFilterParam( {...filterParam, ["card_id"]:cardId,  ["card_id_valid"]:true, ["przypisane"]:'',['przypisane_valid']:true } );
      setTab(null);
}
const onAdded = (idx) => {
        
    setView({...view, ["v"]:"edit", ["id"]:idx }); 
    
   // setFilterParam( {...filterParam, ["card_id"]:"",  ["card_id_valid"]:true } );
   // setTab(null);
}

 const goDelete= (e) =>
    {         
        var ids = new Array();
    
        for(var k=0; k<selectedRow.length; k++)
            {
               if( selectedRow[k].selected == 1)
               {
                    ids.push({
                        id: selectedRow[k].id,
                        title: selectedRow[k].title
                    });
               }
            }
        
    
         if(ids.length < 1)     
         {       
            props.mainView.showDialog(props.userData.dic.dlg_notice_wrong , 'Nie wybrano żadnej karty' ,  "ok"  ,null); 
            return;              
         }
    
    
        props.mainView.showDialog("Potwierdź", "Na pewno chcesz usunąć wybrane karty (" + ids.length + " szt.) ?", "yesno", (option)=>{
              
            ///--------
            if(option == "yes")
            {
                        props.mainView.setProgress(-2);
    
                        var req = {
                            ids: ids,     
                            option: 'delete'                        
                        }
    
                        fetch( Config.url + '/rest_v1_access,cards_update', {
                            method: 'POST', 
                            body: JSON.stringify(req), 
                            headers: {
                                'Content-Type': 'application/json',                    
                                'X-Api-Key': props.userData.apiKey,
                                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                                '_p_dziecko_id_': props.userData.p_dziecko_id,
                                '_sec_key_': Config.genXKey() ,
                            }
                        })
                        .then(res => res.json() )
                        .then(res => { 
    
                                    props.mainView.setProgress(-1);        
                                    if(res._sys_ == undefined)
                                    {
                                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                                    }else
                                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                                    {
                                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                                    }else    
                                    {      
                                        props.mainView.showDialog( "Sukces", "Operacja zakończona sukcesem"   , "ok" , null);                               
                                        getTab();            
                                    }
                        } )
                        .catch(err => {          
                                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                                    props.mainView.setProgress(-1);
                        });
            }//koniec yes
            //--------
        } );
    
    }    

    const goActive = (e) =>
        {         
            var ids = new Array();
        
            for(var k=0; k<selectedRow.length; k++)
                {
                   if( selectedRow[k].selected == 1)
                   {
                        ids.push({
                            id: selectedRow[k].id,
                            title: selectedRow[k].title
                        });
                   }
                }
            
        
             if(ids.length < 1)     
             {       
                props.mainView.showDialog(props.userData.dic.dlg_notice_wrong , 'Nie wybrano żadnej karty' ,  "ok"  ,null); 
                return;              
             }
        
        
            props.mainView.showDialog("Potwierdź", "Na pewno chcesz aktywować wybrane karty (" + ids.length + " szt.) ?", "yesno", (option)=>{
                  
                ///--------
                if(option == "yes")
                {
                            props.mainView.setProgress(-2);
        
                            var req = {
                                ids: ids,     
                                option: 'active'                        
                            }
        
                            fetch( Config.url + '/rest_v1_access,cards_update', {
                                method: 'POST', 
                                body: JSON.stringify(req), 
                                headers: {
                                    'Content-Type': 'application/json',                    
                                    'X-Api-Key': props.userData.apiKey,
                                    '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                                    '_p_dziecko_id_': props.userData.p_dziecko_id,
                                    '_sec_key_': Config.genXKey() ,
                                }
                            })
                            .then(res => res.json() )
                            .then(res => { 
        
                                        props.mainView.setProgress(-1);        
                                        if(res._sys_ == undefined)
                                        {
                                            props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                                        }else
                                        if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                                        {
                                            props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                                        }else    
                                        {      
                                            props.mainView.showDialog( "Sukces", "Operacja zakończona sukcesem"   , "ok" , null);                               
                                            getTab();            
                                        }
                            } )
                            .catch(err => {          
                                        props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                                        props.mainView.setProgress(-1);
                            });
                }//koniec yes
                //--------
            } );
        
        }    
    



    const goDezactive = (e) =>
        {         
            var ids = new Array();
        
            for(var k=0; k<selectedRow.length; k++)
                {
                   if( selectedRow[k].selected == 1)
                   {
                        ids.push({
                            id: selectedRow[k].id,
                            title: selectedRow[k].title
                        });
                   }
                }
            
        
             if(ids.length < 1)     
             {       
                props.mainView.showDialog(props.userData.dic.dlg_notice_wrong , 'Nie wybrano żadnej karty' ,  "ok"  ,null); 
                return;              
             }
        
        
            props.mainView.showDialog("Potwierdź", "Na pewno chcesz dezaktywować wybrane karty (" + ids.length + " szt.) ?", "yesno", (option)=>{
                  
                ///--------
                if(option == "yes")
                {
                            props.mainView.setProgress(-2);
        
                            var req = {
                                ids: ids,     
                                option: 'dezactive'                        
                            }
        
                            fetch( Config.url + '/rest_v1_access,cards_update', {
                                method: 'POST', 
                                body: JSON.stringify(req), 
                                headers: {
                                    'Content-Type': 'application/json',                    
                                    'X-Api-Key': props.userData.apiKey,
                                    '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                                    '_p_dziecko_id_': props.userData.p_dziecko_id,
                                    '_sec_key_': Config.genXKey() ,
                                }
                            })
                            .then(res => res.json() )
                            .then(res => { 
        
                                        props.mainView.setProgress(-1);        
                                        if(res._sys_ == undefined)
                                        {
                                            props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                                        }else
                                        if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                                        {
                                            props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                                        }else    
                                        {      
                                            props.mainView.showDialog( "Sukces", "Operacja zakończona sukcesem"   , "ok" , null);                               
                                            getTab();            
                                        }
                            } )
                            .catch(err => {          
                                        props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                                        props.mainView.setProgress(-1);
                            });
                }//koniec yes
                //--------
            } );
        
        }    
    



 
 if(tab == null)
    {
        setTab([]);
        getTab();
     

        return <div>
            ...
        </div>
    }


    if(refreshView != props.userData.refreshView)
    {         
        setRefreshView( props.userData.refreshView);
        setTab(null);
        setView( {
            v:'list',
            id: -1
        });
    }

    



    if(view.v == 'edit')
        {
            var searchRow = null;
            for(var k=0; k<tab.length; k++)
            {
                if(tab[k].id == view.id) { searchRow = tab[k]; break; }
            }
    
            return <CardsEdit  userData={props.userData} mainView={props.mainView} row={searchRow} onBack={onSuccess} />
        }


        if(view.v == 'new')
            {
                return <CardNew  userData={props.userData} mainView={props.mainView} onBack={onBack} onAdded={onAdded} searchId={searchId} />
            }

        if(view.v == 'import')
            {
                return <CardImport  userData={props.userData} mainView={props.mainView} onBack={onBack} onSuccess={onSuccess} />
            }


        const itemsPrzypisane = [
            { v: '_x_', title: '- - -' },
            { v: '0', title: 'Nieprzypisane' },        
            { v: '1', title: 'Przypisane' },         
        ]; 
    

        var sortList = [ 
            {column: "created_at", name: "Data dodania"       }, 
            {column: "updated_at", name: "Data aktualizacji"  }, 
        ]
    



    var zaznaczonych = 0;
    for(var s=0; s<selectedRow.length; s++)
    {
        if(selectedRow[s].selected == 1) zaznaczonych ++;
    }




    return (

        <div className="view_content">
           


                {
                    filterParam.show == false  &&
                    <div className="  goright link_color" onClick={filterView}>
                        pokaż filtry
                    </div>
                } 


                
                {
                    filterParam.show == true  &&
                    <div className="table_filter">

                            <div className="filter_controll">   
                                <label>Numer karty / CardId: </label>                             
                                <InputText   userData={props.userData} value={filterParam.card_id}   valChange={valChangeListener} goNext={goNextNew} name="card_id" placeholder={"Numer karty: "}   />
                            </div> 

                            <div className="filter_controll">   
                                <label>Szukaj w opisie: </label>                             
                                <InputText   userData={props.userData} value={filterParam.karta_opis}   valChange={valChangeListener} goNext={goNextNew} name="karta_opis" placeholder={"Opis: "}   />
                            </div> 

                            <div className="filter_controll">   
                                <label>Przypisane dziecko: </label>                             
                                <InputTextAlpha   userData={props.userData} value={filterParam.d_imie_nazwisko}   valChange={valChangeListener} goNext={goNextNew} name="d_imie_nazwisko" placeholder={"Dziecko: "}   />
                            </div> 


                            <div className="filter_controll">   
                            <label>Status: </label>                             
                            <InputCombo  items={itemsPrzypisane}  userData={props.userData}  mainView={props.mainView}  value={filterParam.przypisane}   valChange={valChangeListener} goNext={goNextNew} name="przypisane" placeholder={" "}   />
                        </div> 


                            <div className="filter_btn">
                                <span className="link_color" onClick={filterView}>&nbsp;ukryj filtry&nbsp;</span> 
                                <span className="btn" onClick={filterApprove} >filtruj</span>&nbsp;&nbsp;<span className="btn" onClick={filterClear} >wyczyść</span>
                        </div>
                    </div>
                } 


               

                <div className="bg_center">

                            <div className="table_widget">        


                                    <div className="btn" onClick={changeView} v="new" id="-1"  > nowa karta</div>                            
                                    &nbsp; &nbsp;

                                    <div className="btn" onClick={changeView} v="import" id="-1"  > import odbić z innego systemu</div>                            
                                    &nbsp;

                                    <InputPagger filter={filterParam}  onChange={onChangePagger}  />
                                        
                                    <InputLegend items={legend}/>

                                    <SortBy  cols={sortList} param={filterParam.sortBy}  onChange={onChangeSortBy}  />  
                            </div>


                            <div className="table_mass">  

                                <div className="title_mass">Operacje masowe (zaznaczono: {zaznaczonych}) </div>
                             
                                &nbsp;
                             
                                <span className="btn" onClick={goActive} > Aktywuj</span>  
                                &nbsp;
                                <span className="btn" onClick={goDezactive} > Dezaktywuj</span>  

                            </div>

                        <div className="scorll_x">
                            <table className="table" ref={tabRef}>


                                        <thead>
                                                <tr className="header">
                                                    <td className="link_normal td_left" onClick={changeSelectedAll}>Z</td>   
                                                    <td>LP</td>                                                                                                                                           
                                                    <td>CardId</td>                                              
                                                    <td>Aktywna</td>                                              
                                                    <td>Przypisana do</td>                                              
                                                    <td>Opiekun / Os. upow.</td>                                              
                                                    <td>Opis</td>                                                                                              
                                                    <td>Data aktualizacji</td>                                              
                                                    <td className="td_right">Ważna do</td>                                             
                                                    <td className="td_option"> </td>                                              
                                                </tr>
                                        </thead>
                                        <tbody>

                                                {
                                                        tab.map(  (row, inx) => {

                                                                var isChecked = "";

                                                                for(var s=0; s<selectedRow.length; s++)
                                                                    {
                                                                        if( selectedRow[s].id == row.id &&  selectedRow[s].selected == 1) isChecked = "checked";
                                                                    }

                                                                    var css = "";

                                                                    var aktywna = "Nie";
                                                                    if(row.aktywna == "1") aktywna = "Tak";

                                                                    if(row.aktywna == "0") css = " color_deleted ";


                                                                    var rowStyle = " row ";
                                                                    if(inx % 2 == 0 )rowStyle = " row2 ";


                                                                return <tr className={ rowStyle + css} key={inx}>

                                                                        <td className="gocenter">
                                                                        <input type="checkbox" atr-id={row.id} onChange={changeSelected} checked={isChecked} />
                                                                        </td>  
                                                                        <td className="gocenter" >{inx+1}</td>                                                                                                                                           
                                                                        <td className="gocenter">{row.card_id}</td>                                              
                                                                        <td className="gocenter">{aktywna}</td>                                              
                                                                        <td>
                                                                            {
                                                                                row.przypisania.map( (prz,ix) => {
                                                                                    return <div>
                                                                                          {prz.typ}, {prz.imie +" " + prz.nazwisko} , {prz.userID}
                                                                                    </div>
                                                                                } )
                                                                            }
                                                                        </td>                                              
                                                                        <td>
                                                                            {
                                                                                row.przypisania.map( (prz,ix) => {
                                                                                    return <Fragment>

                                                                                           { 
                                                                                                prz.opiekun != null  &&
                                                                                                <span>
                                                                                                   {prz.opiekun.typ}: {prz.opiekun.nazwisko} {prz.opiekun.imie} 
                                                                                                </span>
                                                                                            }
                                                                                         

                                                                                    </Fragment>
                                                                                } )
                                                                            }
                                                                          
                                                                        </td>    
                                                                        <td>{row.opis}</td>                                              
                                                                        <td className="gocenter">{row.updated_at}</td>                                              
                                                                        <td className="gocenter">{row.termin_waznosci_do}</td>                                              
                                      
                                                                        <MenuTable>
                                                                        <ul>
                                                                       
                                                                            <li  onClick={changeView} v="edit" id={row.id}  >zmień dane</li>
                                                                         
                                                                        </ul>                                                               
                                                                       </MenuTable> 


                                                                </tr>

                                                        } )

                                                }

                                        </tbody>

                            </table>
                        </div>

                </div>

        </div>
    )

}


export default Cards;